import { checkParams, zeroUnit, soFarDate, timePeriod } from '../../utils'
import { formatTime, formatDate, formatDatetime } from '../../filter'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	let isPAIC = this.isPAIC && this.isFirstVisit && !this.isCarInsurance
	if (!isPAIC) {
		return false
	}
	const hasCertificate = !(
		injured.certificate &&
		['0', ''].includes(injured.certificate.hasCertificate)
	)

	let certificateList = []
	if (injured.certificate && injured.certificate.certificateList.length) {
		certificateList = injured.certificate.certificateList
	}

	const modal = [
		{
			label: '证件类型',
			value: '',
			key: 'certificateType',
			type: 'select',
			selectOption: setting.certiFiCatetypeList,
			notNull: '1',
			canEdit: true,
			formSpan: 7,
		},
		{
			label: '证件号',
			value: '',
			key: 'certificateNo',
			type: 'text',
			length: 30,
			notNull: '1',
			canEdit: true,
			formSpan: 8,
			rules: [
				{
					max: 30,
					message: '长度不能超过30位',
					trigger: 'blur',
				},
			],
		},
	]

	const list = certificateList.map((item, index) => {
		const valArr = [item.certificateType, item.certificateNo]

		let arr = modal.map((moadlItem, valIndex) => {
			return {
				...moadlItem,
				value: valArr[valIndex],
			}
		})

		return {
			list: arr,
		}
	})

	const obj = {
		title: '证件（资格证）信息',
		key: 'certificate.certificateList', // 提交时对应的字段
		modal: modal, // 每一行的模板
		children: list, // 数据列表
		certificate: {
			hasCertificate: hasCertificate,
		},
	}

	return obj
}
